import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { ADMIN_API_ENDPOINTS } from "../../common/api-endpoints";
import { PageResultDto } from "../../dto";

const BASE = ADMIN_API_ENDPOINTS.FNB_PRODUCTS;

export interface FnbProductApiItem {
  id: string;
  name?: string | { en?: string; kh?: string };
  description?: string | { en?: string; kh?: string };
  categoryId?: string;
  categoryName?: string | { en?: string; kh?: string };
  basePrice?: number;
  enabled?: boolean;
  productGroups?: Array<{
    option_group?: string | { en?: string; kh?: string };
    required?: boolean;
    multiple_choice?: boolean;
    options?: Array<{
      id?: string;
      name?: string | { en?: string; kh?: string };
      extra_price?: number;
      is_default?: boolean;
    }>;
  }>;
  imageId?: string;
  image?: { id?: string; url?: string };
  [key: string]: unknown;
}

export interface FindFnbProductDto {
  search?: string;
  limit?: number;
  offset?: number;
  categoryId?: string;
  enabled?: boolean;
  mallId?: string;
  offlineTenantId?: string;
}

@Injectable({ providedIn: "root" })
export class FnbProductApiService {
  constructor(private httpService: HttpService) {}

  async find(params?: FindFnbProductDto): Promise<{ rows: FnbProductApiItem[]; count: number }> {
    const result = await this.httpService.get<PageResultDto<FnbProductApiItem>>(BASE, params as any);
    return {
      rows: result?.rows ?? [],
      count: result?.count ?? 0,
    };
  }

  async findOne(id: string): Promise<FnbProductApiItem | null> {
    try {
      const result = await this.httpService.get<FnbProductApiItem>(`${BASE}/${id}`);
      return result ?? null;
    } catch {
      return null;
    }
  }

  async create(dto: Record<string, unknown>): Promise<FnbProductApiItem> {
    return await this.httpService.post<FnbProductApiItem>(BASE, dto);
  }

  async update(id: string, dto: Record<string, unknown>): Promise<FnbProductApiItem> {
    return await this.httpService.put<FnbProductApiItem>(`${BASE}/${id}`, dto);
  }

  async delete(id: string): Promise<void> {
    await this.httpService.delete(`${BASE}/${id}`);
  }

  async setEnabled(id: string, enabled: boolean): Promise<void> {
    // Backend expects update on /v1/fnb-products/:id with payload { enabled }
    await this.httpService.put(`${BASE}/${id}`, { enabled });
  }
}
